module.exports = __webpack_public_path__ + "static/media/earning_without_detail_title.74143b8a.svg";